/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSouscriptionSupportingDocumentsMutation from '../graphql/mutations/SaveSouscriptionSupportingDocumentsMutation.js';

export const useSaveSouscriptionSupportingDocumentsMutation = () => {
  return useCommitMutation(SaveSouscriptionSupportingDocumentsMutation, {
    dataProp: 'saveSouscriptionSupportingDocuments_M_souscription_supporting_documents'
  });
};

export default useSaveSouscriptionSupportingDocumentsMutation;
